/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react'
import { Field } from 'redux-form'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { sh, ah, ReduxWrapper, compose } from 'common-data/datahelpers'
import { FAIcon } from './FAIcon'
import moment from 'moment'
import _ from 'lodash'
import clsx from 'clsx'

export const DateIsAvailableTypes = {
  TodayAndPast: 'TodayAndPast',
  TodayAndFuture: 'TodayAndFuture',
  OnlyPast: 'OnlyPast',
  OnlyFuture: 'OnlyFuture'
}

function tryParseDate (input) {
  const finalMatch = {
    inputFormat: 'None',
    displayFormat: '',
    output: 'Invalid',
    value: input
  }
  var regex = /^\d{2}\/\d{2}\/(\d{2}|\d{4})$/;
  const matchedFormat = regex.test(input);
  const numberValidation = matchedFormat ? new Date(input) : input;
  if(!matchedFormat)
  {
    const inputIsDate = moment.isDate(input)
    const inputIsMoment = moment.isMoment(input)
    if (inputIsMoment || inputIsDate) {
      if (inputIsMoment) {
        finalMatch.value = input
      } else {
        finalMatch.value = moment.utc(input)
      }
      finalMatch.inputFormat = 'MM/DD/YYYY'
      finalMatch.displayFormat = 'MM/DD/YYYY'

      finalMatch.output = finalMatch.value.format(finalMatch.displayFormat)
      return finalMatch
    }
  }

  // MDYY
  // M?D?YY
  // MMDDYY
  // MMDDYYYY

  const testFormats = [
    'MMDDYY',
    'MMDDYYYY',
    'MM/DD/YYYY',
    'MMYY',
    'M/D/YY',
    'M/D/YYYY',
    moment.ISO_8601
  ]
  let test = String(input)
  const isNum = !isNaN(numberValidation)
  const currentYearPart = Number(moment().format('YY'))
if(test.length == 4 && isNum){
  const yearPart = test.substring(2,4)
  const yearPartText = _.padStart(_.padStart(yearPart, 2, '0'), 4, currentYearPart >= yearPart ? '20' : '19')

  const monthPartSingle = test.substring(0, 1)
  const monthPartDouble = test.substring(0, 2)
  const monthPartSingleText = _.padStart(monthPartSingle, 2, '0')
  const dayPart = '01';
  if (monthPartDouble > 12) {
    test = `${monthPartSingleText}${dayPart}${yearPartText}`
  } else {
    test = `${monthPartDouble}${dayPart}${yearPartText}`
  }
} else if (test.length === 5 && isNum) {
    const yearPart = Number(test.substring(3))
    const yearPartText = _.padStart(_.padStart(yearPart, 2, '0'), 4, currentYearPart >= yearPart ? '20' : '19')

    const monthPartSingle = Number(test.substring(0, 1))
    const monthPartDouble = Number(test.substring(0, 2))
    const monthPartSingleText = _.padStart(monthPartSingle, 2, '0')
    const monthPartDoubleText = _.padStart(monthPartSingle, 2, '0')

    const dayPartSingle = Number(test.substring(2, 3))
    const dayPartDouble = Number(test.substring(1, 3))
    const dayPartSingleText = _.padStart(dayPartSingle, 2, '0')
    const dayPartDoubleText = _.padStart(dayPartDouble, 2, '0')

    // console.log(`MPS: ${monthPartSingle}, MPD: ${monthPartDouble}, DPS: ${dayPartSingle}, DPD: ${dayPartDouble}`)

    if (monthPartSingle === 0) {
      test = test.substring(1);
      let dayText = `0${test.substring(1, 2)}`;
      if(dayText == '00'){
        dayText = '01';
      }
      test = `0${test.substring(0, 1)}${dayText}${yearPartText}`
    } else {
      let daypart = dayPartDoubleText;
      if(dayPartDoubleText > 31){
daypart = '01';
      }
      if (monthPartDouble > 12) {
        test = `${monthPartSingleText}${daypart}${yearPartText}`
      } else if (monthPartSingle === 1) {
        test = `${monthPartDoubleText}${daypart}${yearPartText}`
      } else {
        test = `${monthPartDoubleText}${daypart}${yearPartText}`
      }
    }

    // console.log(`Test: ${test}`)
  }

  if (input && test.length > 3 && isNum) {
    for (var testFormat of testFormats) {
      var testResult = moment.utc(test, testFormat, true)
      if (testResult.isValid()) {
      // adjust year if needed
        const yearNumber = testResult.year()
        if (yearNumber > 1999) {
          const yearPart = Number(String(yearNumber).substring(2))

          // dont allow year value greater than 5 years in the future
          const currentYearNumber = moment().year()
          if ((yearNumber - currentYearNumber) > 4) {
            if (yearPart > currentYearPart) {
              testResult.subtract(100, 'years')
            }
          }
        }
        finalMatch.inputFormat = testFormat
        finalMatch.displayFormat = 'MM/DD/YYYY'
        finalMatch.output = testResult.startOf('day').format(finalMatch.displayFormat)
        finalMatch.value = testResult.startOf('day')
        break
      }
    }
  } else {
    finalMatch.inputFormat = 'None'
    finalMatch.displayFormat = ''
    finalMatch.output = 'Invalid'
    finalMatch.value = ''
  }

  return finalMatch
}

export function DateBoxInit () {
  const calInput = document.createElement('input')
  window.mcdptInput = calInput
  calInput.id = 'calInput'
  calInput.classList.add('hide')
  calInput.type = 'text'
  document.body.appendChild(calInput)
  // eslint-disable-next-line no-undef
  const datePicker = MCDatepicker.create({
    el: '#calInput'
  })
  window.mcdpt = datePicker
}

function DateBoxPlainHook (props) {
  const { SessionAccount, formSetValidationFields, formClearValidationFields, ...rest } = props

  const { input: { onBlur, onChange, name, value }, meta: { form, initial }, groupButton, groupLabel } = rest

  const datePicker = useRef(null)
  const [ currentValue, setCurrentValue ] = useState()
  const [ initialParseComplete, setInitialParseComplete ] = useState(false)

  useEffect(() => {
    return () => {
      if (datePicker.current) {
        if (_.isFunction(datePicker.current.destory)) {
          datePicker.current.destory()
        }
      }
    }
  }, [])

  useEffect(() => {
    if (initial && !initialParseComplete) {
      const initialValue = _.has(initial, 'Value') ? initial.Value : initial
      const parseRet = tryParseDate(initialValue)
      if (parseRet.output === 'Invalid' && parseRet.value) {
        formSetValidationFields(form, { Name: name, Value: `"${name}" must be a valid date` })
        setCurrentValue(parseRet.value)
      } else {
        setCurrentValue(parseRet.output === 'Invalid' ? '' : parseRet.output)
      }
      setInitialParseComplete(true)
    }
  }, [initial, initialParseComplete])

  useEffect(() => {
    if (!isNaN(value)) {

      const parseRet = tryParseDate(value)
      // console.log({ value, parseRet })
      if (parseRet.output === 'Invalid' && parseRet.value) {
        formSetValidationFields(form, { Name: name, Value: `"${name}" must be a valid date` })
        setCurrentValue(parseRet.value)
      } else {
        setCurrentValue(parseRet.output === 'Invalid' ? '' : parseRet.output)
      }
      setInitialParseComplete(true)
    }
  }, [value])

  function handleOnBlur (e) {
    // console.log('blur')
    if ((e.target.value || e.target.value == '') && _.isFunction(onBlur)) {
      const parseRet = tryParseDate(e.target.value)
      if (parseRet.output === 'Invalid' && parseRet.value) {
        formSetValidationFields(form, { Name: name, Value: `"${name}" must be a valid date` })
        onBlur(parseRet.value)
      } else {
        formClearValidationFields(form, name)
        setCurrentValue(parseRet.output === 'Invalid' ? '' : parseRet.output)
        onBlur(parseRet.value)
      }
      onChange(parseRet.value)
    } else {
      onBlur(null)
    }
  }

  function handleOnChange (e) {
    setCurrentValue(e.target.value)
  }

  function onPickerClick () {
    if (!datePicker.current) {
      datePicker.current = MCDatepicker.create({})
      datePicker.current.onSelect(onPickerSelect)
    }
    const curval = tryParseDate(currentValue)
    if (curval.output !== 'Invalid') {
      datePicker.current.setFullDate(new Date(curval.value.year(), curval.value.month(), curval.value.date()))
    }
    datePicker.current.open()
  }

  function onPickerSelect (date) {
    datePicker.current.close()
    const parseRet = tryParseDate(date)
    if (parseRet.output === 'Invalid' && parseRet.value) {
      formSetValidationFields(form, { Name: name, Value: `"${name}" must be a valid date` })
      setCurrentValue(parseRet.value)
      onChange(null)
    } else {
      setCurrentValue(parseRet.output === 'Invalid' ? '' : parseRet.output)
      onChange(parseRet.value)
    }
  }

  useEffect(() => {}, [groupButton])

  return (
    <FieldLayoutBox {...rest}>
      {({ testId, showError, value, name, placeHolder, loading, readonly }) => {
        if (readonly) {
          return <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
            <input data-tid={testId} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')}
              type='text' readOnly name={`view${name}`} id={`view${name}`} value={value?.format('MM/DD/YYYY')} />
          </FieldLayoutGroup>
        } else {
          return <FieldLayoutGroup groupButton={{
            onClick: onPickerClick,
            tabIndex: -1,
            text: <FAIcon name='calendar' />,
            color: 'secondary'
          }}>
            <input data-tid={testId} className={clsx(showError && 'is-invalid-input', 'input-group-field')} type='text' name={`date${name}`} id={`date${name}`} onBlur={handleOnBlur} onChange={handleOnChange} value={currentValue} />
          </FieldLayoutGroup>
        }
      }}
    </FieldLayoutBox>
  )
}

const DateBoxClass = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
    ah.formSetValidationFields,
    ah.formClearValidationFields
  ])
)(DateBoxPlainHook)

export const DateBox = ({ parse, format, fieldType = FieldValueConverters.Date, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={DateBoxClass} /> } // eslint-disable-line
export default DateBox
